export default __webpack_public_path__ + "static/media/ic_dot_24.4e671b07.svg";